<template>
  <div class="md-layout file_input_box">
    <div class="up_box md-layout-item">
      <md-field :class="[{ 'md-error': errors.has('debtor') }]">
        <label>{{ $t("seller.upload.excel.select.title") }}</label>
        <md-input v-model="fileName" type="text"></md-input>
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
      </md-field>
      <div class="excel_input_box">
        <el-upload
          class="avatar-uploader el-upload--text"
          :show-file-list="false"
          action
          :on-success="handleVideoSuccess"
          :before-upload="beforeUpload"
          :on-progress="uploadVideoProcess"
          :on-change="handleChange"
          :data="paramsdata"
          ref="uploadXml"
          :disabled="isLoading || disable"
          show-text="false"
          accept=".xsl, .xml, .xlsx, .csv"
          drag
          :http-request="uploadSectionFile"
        ></el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import {file} from "../../../common/api/file.js";
import {receivableApi} from "@/common/api/receivableApi";
import {getToken} from "@/common/utils/auth"; // getToken from cookie

export default {
  props: {
    filType: String,
    filUrl: String,
    upType: { type: [String, Number], default: 1 },
    disable: Boolean,
    iconName: { type: String, default: "fa-ﬁle-text" },
    accept: { type: String, default: "" }
  },
  data() {
    return {
      uploadUrl: "http://api.jintaiji.vip/jtj/web-api/file/uploadVideo", //你要上传视频到你后台的地址
      videoFlag: true, //是否显示进度条
      videoUploadPercent: "", //进度条的进度，
      isShowUploadVideo: false, //显示上传按钮
      showVideoPath: "",
      form: {
        data: "",
        name: "",
        type: ""
      },
      file: "",
      tokenHead: "",
      paramsdata: {
        token: ""
      },
      isLoading: false,
      r100: 100,
      r50: 50,
      fileCheck: false,
      acceptList: {
        pdf: "application/pdf"
      },
      fileName: ""
    };
  },
  mounted() {
    this.showVideoPath = this.filUrl;
    this.fileReader = new FileReader();
    this.tokenHead = getToken() || "";
    this.paramsdata.token = this.tokenHead;
  },
  methods: {
      uploadSectionFile(params) {
      var option = {
        file: params.file,
      };
      receivableApi
        .uploadXml(option)
        .then(res => {
          this.$emit('isUpload',true);
          this.toastSuccess(res.msg)
        })
        .catch(err => {
          console.log("err", err);
          this.toast(err)
        });
    },
    beforeUpload(file, fileList) {
      this.isShowUploadVideo = false;
      this.fileName = file.name;
      this.checkFile(file);
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.isLoading = true;
      //   if (!this.fileCheck) return;
      this.$emit("chageFile", { isLoading: this.isLoading });
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
      this.$emit("changePercent", this.videoUploadPercent);
    },
    submitUpload(e) {
      this.fileReader.readAsDataURL(this.file);
      this.fileReader.onload = () => {
        let base64Str = this.fileReader.result;
        this.imageUrl = base64Str;
        this.form.data = base64Str.split(",")[1];
        this.form.name = this.file.name;
        let tm = this.file.name;
        let strNum = tm.lastIndexOf(".");
        let typeStr = tm.substring(strNum + 1, tm.length);
        this.form.type = typeStr;
        this.UploadFile();
      };
    },
    handleChange(file, fileList) {},
    checkFile(file) {
      this.fileCheck = true;
      const maxSize = file.size / 1024 / 1024 <= 200;

      //   if (file.type === this.realAccept && maxSize) {
      //     this.fileCheck = true;
      //   } else {
      //     this.fileCheck = false;
      //     this.toast(this.$t("seller.upload.errorTip"));
      //   }
    },
    UploadFile() {
      let option = {
        file: this.file
      };
      file
        .UploadVideo(option)
        .then(res => {
          if (res && res.code == 0) {
            this.centerDialogVisible = false;
            // Jason:
            // ?type=mgr&token=
            // let {token}=res.head
            //  this.tokenHead
            var token = this.tokenHead;
            var tokenUri = encodeURIComponent(token);
            this.fileList = [];
            this.showVideoPath = res.url + "?type=mgr&token=" + tokenUri;
            this.videoUploadPercent = 100;
            this.videoFlag = false;
            // encodeURI
            this.$emit("chageFile", {
              data: res.url,
              isLoading: this.isLoading
            });
          } else {
            this.toast(res.msg);
          }
        })
        .catch(err => {
          this.centerDialogVisible = false;
          this.fileList = [];
        });
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isLoading = false;
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      if (res && res.code == 0) {
        this.centerDialogVisible = false;
        var token = this.tokenHead;
        var tokenUri = encodeURIComponent(token);
        this.fileList = [];
        this.showVideoPath = res.url + "?type=mgr&token=" + tokenUri;
        this.videoUploadPercent = 100;
        this.videoFlag = false;
        this.$emit("chageFile", { data: res.url, isLoading: this.isLoading });
      } else {
        this.toast(res.msg);
      }
    }
  },
  computed: {
    realUrl() {
      let filUrl = this.filUrl || this.showVideoPaths || "";
      var tokenUri = encodeURIComponent(this.tokenHead);
      if (filUrl) {
        filUrl = filUrl + "?type=mgr&token=" + tokenUri;
      }
      return filUrl;
    },
    realAccept() {
      let acceptList = this.acceptList;
      let accept = this.accept;
      return acceptList[accept];
    }
  },
  watch: {
    realUrl() {
      if (this.filUrl) {
        this.showVideoPath = this.filUrl;
      }
    },
    disable() {
      if (!this.disabled) {
        this.isLoading = false;
        this.videoUploadPercent = 0;
      }
    }
  }
};
</script>
<style scoped>
.file_input_box {
  position: relative;
}
.excel_input_box {
  position: absolute;
  top: 0;
  opacity: 0;
}
</style>
